import { useQuery } from '@tanstack/react-query';
import type { Company } from '@faktorplus/shared';
import { apiRequest } from '../lib/api-client';
import { queryKeys } from '../lib/query-keys';

/**
 * The company's own identity — buyer on every invoice, orderer on every
 * purchase order. It comes from the API's environment and cannot change while
 * the app is open, so it is fetched once and never refetched.
 */
export function useCompany() {
  return useQuery({
    queryKey: queryKeys.company.all,
    queryFn: () => apiRequest<Company>('/company'),
    staleTime: Infinity,
  });
}
